import { Reducer } from 'redux';
import { BaseAction } from 'redux-actions';

import type { CallFlowTypeT } from '../api/types';
import {
  CHANGE_ACTIVE,
  CHANGE_NAME,
  CHANGE_NUMBER,
  CHANGE_STATUS,
  FLOW_FETCH_FAILED,
  FLOW_FETCH_SUCCEEDED,
  FLOW_UPDATE_FAILED,
  FLOW_UPDATE_SUCCEEDED,
  FLUSH,
  UNSAVED_CHANGES,
} from '../constants/actionTypes';

export type CallFlowStateT = {
  active: boolean;
  hasUnSavedChanges: boolean;
  id: null | string;
  name: string;
  number: string;
  status: string;
};

type FlowCallActionTypeT = BaseAction &
  (
    | FlowCallFetchActionT
    | FlowCallUnsavedChagesActionT
    | FlowCallChangeNameActionT
    | FlowCallChangeNumberActionT
    | FlowCallChangeActiveActionT
    | FlowCallChangeStatusActionT
    | any
  );

type FlowCallFetchActionT = {
  flow: CallFlowTypeT;
};

type FlowCallUnsavedChagesActionT = {
  hasChanged: boolean;
};

type FlowCallChangeNameActionT = {
  name: string;
};

type FlowCallChangeNumberActionT = {
  number: string;
};

type FlowCallChangeActiveActionT = {
  isActive: boolean;
};

type FlowCallChangeStatusActionT = {
  status: string;
};

const initialState: CallFlowStateT = {
  active: false,
  hasUnSavedChanges: false,
  id: null,
  name: '',
  number: '',
  status: '',
};

export const callFlow: Reducer<CallFlowStateT> = (
  state: CallFlowStateT = initialState,
  action: FlowCallActionTypeT,
) => {
  switch (action.type) {
    case FLUSH:
      return Object.assign({}, state, initialState);
    case FLOW_FETCH_SUCCEEDED: {
      const newFlow = Object.assign({}, action.flow);
      delete newFlow.nodes;
      return newFlow;
    }
    case UNSAVED_CHANGES:
      return Object.assign({}, state, { hasUnSavedChanges: action.hasChanged });
    case FLOW_FETCH_FAILED:
      return Object.assign({}, state, initialState, { status: 'error' });
    case FLOW_UPDATE_SUCCEEDED:
      return Object.assign({}, state, {
        status: 'complete',
        hasUnSavedChanges: false,
      });
    case CHANGE_NAME:
      return Object.assign({}, state, {
        name: action.name,
        hasUnSavedChanges: true,
      });
    case CHANGE_NUMBER:
      return Object.assign({}, state, {
        number: action.number,
        hasUnSavedChanges: true,
      });
    case FLOW_UPDATE_FAILED:
      return Object.assign({}, state, { status: 'error' });
    case CHANGE_ACTIVE:
      return Object.assign({}, state, {
        active: action.isActive,
        hasUnSavedChanges: true,
      });
    case CHANGE_STATUS:
      return Object.assign({}, state, { status: action.status });
    default:
      return state;
  }
};
